import { gql, useMutation } from '@apollo/client';
import { useEffect } from 'react';
import { useCalculationInput } from 'src/common/context';
import type { StartCalculationsMutation, StartCalculationsMutationVariables } from '../types/types';

export const START_CALCULATIONS = gql`
  mutation StartCalculations($input: CalculationInput!, $subscriptionId: String!) {
    startCalculations(input: $input, subscriptionId: $subscriptionId) {
      subscriptionId
      brandCode
      isLast
    }
  }
`;

export function useStartCalculations(subscriptionId: string | null) {
  const { calculationInput } = useCalculationInput();

  const [startCalculations, { data, error }] =
    useMutation<StartCalculationsMutation, StartCalculationsMutationVariables>(START_CALCULATIONS);

  useEffect(() => {
    if (!calculationInput || !subscriptionId) return;
    // Rejects on a GraphQL error (client errorPolicy 'none'); the failure is exposed via
    // `error` below and a denial is toasted by rateLimitErrorLink — nothing to rethrow.
    startCalculations({ variables: { input: { ...calculationInput, brandCode: undefined }, subscriptionId } }).catch(
      () => undefined,
    );
  }, [calculationInput, subscriptionId, startCalculations]);

  return { data, error };
}
